import { defineMobileFormWindow } from "@app/overlay";
import {
    WsLimitCardsFilterForm,
    type WsLimitCardsFilterFormProps,
} from "./components/WsLimitCardsFilter/WsLimitCardsFilterForm";

/** Реестр overlay-окон списка лимитных карт УП. */
export const wsLimitCardsListWindows = {
    filter: defineMobileFormWindow<WsLimitCardsFilterFormProps>({
        key: "workshop.limitCards.filter",
        title: "Фильтр ЛК УП",
        component: WsLimitCardsFilterForm,
    }),
};
